export default {
  "languageDisplayName": "Deutsch",
    "greeting": "Hallo",
    "Profile": "Profil",
    "Interests": "Interessen",
    "Recurring Payments": "Wiederkehrende Zahlungen",
    "Payment Methods": "Zahlungsarten",
    "Transactions": "Transaktionen",
    "Passport": "Reisepass",
    "Wallet": "Brieftasche",
    "Subscriptions": "Abonnements",
    "Projects": "Projekte",
    "Campaigns": "Kampagnen",
    "Volunteer": "Freiwillige",
    "Events": "Veranstaltungen",
    "Settings": "Die Einstellungen",
    "My": "Meine",
    "Groups": "Gruppen",
    "Awards": "Auszeichnungen",
    "Change": "Veränderung",
    "Image": "Bild",
    "You have no": "Du hast keinen",
    "Now": "Jetzt",
    "Booths": "Stände",
    "Add": "Hinzufügen",
    "You Might Like: ": "Du magst vielleicht: ",
    "Start Date": "Anfangsdatum",
    "End Date": "Endtermin",
    "Payment Method": "Bezahlverfahren",
    "Filter": "Filter",
    "Download": "Herunterladen",
    "Saved Cards": "Gespeicherte Karten",
    "Saved Debits": "Gespeicherte Belastungen",
    "Recommended": "Empfohlen",
    "Subscribe": "Abonnieren",
    "Unsubscribe": "Abmelden",
    "Click to": "Klicke um",
    "Update": "Aktualisieren",
    "Register": "Registrieren",
    "Unregister": "Abmelden",
    "Add More Interests": "Fügen Sie weitere Interessen hinzu",
    "Add More Skills": "Fügen Sie weitere Fähigkeiten hinzu",
    "Search": "Suche",
    "Close": "Schließen",
    "Debit": "Lastschrift",
    "debit": "Lastschrift",
    "Credit Card": "Kreditkarte",
    "card": "Kreditkarte",
    "Cancel": "Stornieren",
    "Save": "Sparen",
    "Account Name": "Kontobezeichnung",
    "Institution Name": "Institutionsname",
    "BSB Number": "BSB-Nummer",
    "Account Number": "Accountnummer",
    "Cardholder Name": "Name des Karteninhabers",
    "Card Number": "Kartennummer",
    "Expiration Date": "Haltbarkeitsdatum",
    "Cannot Be Empty": "Kann nicht leer sein",
    "Not Valid": "Ungültig",
    "Cannot Be Empty or Contain Numbers": "Kann nicht leer sein oder Zahlen enthalten",
    "Login": "Einloggen",
    "Logout": "Ausloggen",
    "Offline": "Offline",
    "No Popups": "Wir haben festgestellt, dass Sie Pop-ups blockiert haben. Bitte stellen Sie sicher, dass diese für diese Seite aktiviert sind.",
    "Awaiting Login": "Warten auf Anmelden",
    "Awaiting Registration" : "Warten auf Registrierung",
    "Please": "Bitte",
    "Voting": "Wählen",
    "Site Settings": "Seiteneinstellungen",
    "My Settings": "Meine Einstellungen",
    "Security Settings": "Sicherheitseinstellungen",
    "2-Factor Authentication": "2-Faktor-Authentifizierung",
    "Language": "Sprache",
    "Name": "Name",
    "Addresses": "Adressen",
    "Work": "Arbeit",
    "Home": "Zuhause",
    "Other": "Andere",
    "Phone Numbers": "Telefonnummern",
    "Email Addresses": "E-mailadressen",
    "First Name": "Vorname",
    "Last Name": "Familienname Nachname",
    "Address Type": "Adresstyp",
    "Street Address 1": "Adresse 1",
    "Street Address 2": "Adresse 2",
    "City": "Stadt",
    "State": "Zustand",
    "Postcode": "Postleitzahl",
    "Country": "Land",
    "Phone Number Type": "Telefonnummer Typ",
    "Email Type": "E-Mail-Typ",
    "Custom Type": "Benutzerdefinierter Typ",
    "Number": "Nummer",
    "Email": "Email",
    "Emails": "Emails",
    "Phone": "Telefon",
    "Phones": "Telefone",
    "Address": "Adresse",
    "Add Address": "Adresse Hinzufügen",
    "Add Phone": "Telefon Hinzufügen",
    "Add Email": "E-Mail Hinzufügen",
    "Accommodation": "Unterkunft",
    "Mobile": "Mobiltelefon",
    "View": "Aussicht",
    "No Groups": "Sie haben keine Gruppen",
    "Recommended Groups": "Empfohlene Gruppen",
    "Roles": "Rollen",
    "Admin": "Administrator",
    "Photos": "Fotos",
    "Join": "Beitreten",
    "Leave" :  "Verlassen",
    "Joined": "Beigetreten",
    "Member": "Mitglied",
    "Members": "Mitglieder",
    "Are you sure?": "Bist du sicher?",
    "Yes": "Ja",
    "No": "Nein",
    "Fitness": "Fitness",
    "Help": "Hilfe",
    "Gallery": "Galerie",
    "Support": "Unterstützung",
    "Unsupport": "Nicht Unterstützt",
    "Skills": "Kompetenzen",
    "Communities": "Gemeinschaften",
    "Click here to enter": "Klicken Sie hier, um teilzunehmen",
    "Rooms": "Räume",
    "Boards": "Bretter",
    "Cloud": "Wolke",
    "Future": "Zukunft",
    "Churches": "Kirchen",
    "Password": "Passwort",
    "password": "passwort",
    "New Password": "Neues Passwort",
    "Old Password": "Altes Passwort",
    "Confirm Password": "Bestätige das Passwort",
    "Subscribers": "Abonnenten",
    "Browse" : "Durchsuche",
    "Past Events" : "Vergangene Ereignisse",
    "Future Events" : "Zukünftige Ereignisse",
    "Create": "Erstellen",
    "Edit" :  "Bearbeiten",
    "Issues" : "Probleme",
    "Organizer" : "Veranstalter",
    "Next" : "Nächster",
    "Back" : "Zurück",
    "Confirm" : "Bestätigen",
    "Select Payment Method": "Wählen Sie Zahlungsmethode",
    "Please provide a payment method" : "Bitte geben Sie eine Zahlungsmethode an",
    "Select A Support Level" : "Wählen Sie Einen Support-Level Aus",
    "Your support will be sent from your selected payment method:": "Ihre Unterstützung wird von Ihrer ausgewählten Zahlungsmethode gesendet:",
    "My Gallery" : "Meine Gallerie",
    "Local Artists" : "Lokale Künstler",
    "My Fitness" : "Meine Fitness",
    "Next Due" : "Als Nächstes Fällig",
    "Frequency" : "Frequenz",
    "Status" : "Status",
    "Link Your Fitbit" : "Verknüpfen Sie Ihren Fitbit",
    "Link Your Strava" : "Verknüpfen Sie Ihre Strava",
    "Active" : "Aktiv",
    "Cancelled" : "Abgebrochen",
    "Tracker" : "Tracker",
    "Mobile Number" : "Handynummer",
    "Day" : "Tag",
    "Month": "Monat",
    "Year" : "Jahr",
    "Date Of Birth" : "Geburtsdatum",
    "Sign Up" : "Anmelden",
    "Check In": "Check-In",
    "News" : "Nachrichten",
    "Deregister" : "Abmelden",
    "What's On" : "Was ist los",
    "On Now" : "Passiert Jetzt",
    "Coming Up" : "Passiert Bald",
    "There are currently no upcoming events" : "Derzeit gibt es keine bevorstehenden Veranstaltungen.",
    "Next Up" : "Nächster",
    "Near Me" : "Nahe bei mir",
    "Goals" : "Tore",
    "Connect" : "Verbinden",
    "Select An Option" : "Wähle Eine Option",
    "Mentors": "Mentoren",
    "Employment": "Beschäftigung",
    "Log In" : "Einloggen",
    "Log Out" : "Ausloggen",
    "Please log in or sign up to continue." : "Bitte melden Sie sich an oder registrieren Sie sich, um fortzufahren.",
    "Add your group" : "Fügen Sie Ihre Gruppe hinzu",
    "Preferred" : "Bevorzugt",
    "Read More" : "Weiterlesen",
    "Description" : "Beschreibung",
    "Submit" : "Einreichen",
    "Subject" : "Gegenstand",
    "Message" : "Botschaft",
    "Send Me A Copy" : "Sende Mir Eine Kopie",
    "Contacts" : "Kontakte",
    "Followers" : "Anhängerinnen",
    "Follow" : "Folgen",
    "Following" : "Das Folgende",
    "Contact Number": "Kontakt Nummer",
    "Any unsaved information may be lost" : "Nicht gespeicherte Informationen können verloren gehen",
    "Add Location": "Ort hinzufügen",
    "Edit Location" : "Standort ändern",
    "Last Logged In" : "Zuletzt angemeldet",
    "Your Connections" : "Ihre Verbindung",
    "There are no connections currently linked to your account" : "Derzeit sind keine Verbindungen zu Ihrem Konto verknüpft",
    "Connection Type" : "Verbindungstyp",
    "Remove Connection" : "Verbindung entfernen",
    "Connect To: " : "Verbinde dich mit: ",
    "Timezone" : "Zeitzone",
    "forgotPassword": "Ich kenne mein Passwort nicht",
    "createNewAccount": "Neuen account erstellen",
    "logInWith": "Einloggen mit",
    "orEnterYour": "oder gib deinen",
    "usernameOrEmail": "benutzernamen oder e-mail",
    "passwordRequired":  "Password is required",
    "enterPasswordFor": "passwort eingeben für",
    "authenticationFailed": "authentifizierung fehlgeschlagen",
    "signIn": "einloggen",
    "iHaveAnAccount": "ich habe einen account",
    "termsAndPrivacy": "allgemeine geschäftsbedingungen und datenschutzerklärung",
    "securedBy": "gesichert durch",
    "Delete": "Löschen",
    "Please Wait" : "Warten Sie mal",
    "loadingDiscussions" : "Wir laden Ihre Chat-Diskussionen!",
    "No Discussions" : "Keine Diskussionen!",
    "joinDiscussion" : "Nehmen Sie an einer Diskussion teil, damit es hier angezeigt wird!",
    "Discussion" : "Diskussion",
    "Log in with :" : "Einloggen mit:",
    "Powered By:" : "Unterstützt von:",
    "Please accept the latest" : "Bitte akzeptieren Sie die neueste",
    "Terms" : "Geschäftsbedingungen",
    "Privacy Policy" : "Datenschutzbestimmungen",
    "terms" : "geschäftsbedingungen",
    "privacy policy" : "datenschutzbestimmungen",
    "willRecieveFollowingInfo" : "erhalten Sie folgende Informationen:",
    "Email Address" : "E-Mail-Addresse",
    "and" : "und",
    "We Use Cookies" : "Wir verwenden Cookies",
    "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Cookies helfen uns bei der Abwicklung vieler Prozesse, die unsere Plattform erfordert. Bitte akzeptieren Sie unsere verfügbaren Einstellungen oder überprüfen Sie sie",
    "ACCEPT ALL" : "AKZEPTIERE ALLE",
    "REJECT ALL" : "ALLES ABLEHNEN",
    "ACCEPT CURRENT SELECTION" : "AKTUELLE AUSWAHL AKZEPTIEREN",
    "SETTINGS" : "EINSTELLUNGEN",
    "Manage cookie preferences" : "Cookie-Einstellungen verwalten",
    "Close modal" : "Modal schließen",
    "Strictly Necessary cookies" : "Unbedingt notwendige Cookies",
    "These cookies are essential for the proper functioning of the website and cannot be disabled." : "Diese Cookies sind für das ordnungsgemäße Funktionieren der Website unerlässlich und können nicht deaktiviert werden.",
    "Performance and Analytics" : "Leistung und Analyse",
    "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you." : "Diese Cookies sammeln Informationen darüber, wie Sie unsere Website nutzen. Sämtliche Daten werden anonymisiert und lassen keinen Rückschluss auf Ihre Person zu.",
    "ACCEPT REQUIRED" : "AKZEPTIEREN ERFORDERLICH",
    "Terms and Privacy Policy Links" : "Allgemeine Geschäftsbedingungen und Links zu Datenschutzrichtlinien",
    "Services" : "Dienstleistungen",
    "Profile Pages": "Profilseiten",
    "Success" : "Erfolg",
    "Your disconnection request has successfully been processed" : "Ihre Anfrage zum Trennen der Verbindung wurde erfolgreich bearbeitet",
    "Disconnecting will cause a new authorization prompt on next login to any related services" : "Durch das Trennen der Verbindung wird bei der nächsten Anmeldung bei allen zugehörigen Diensten eine neue Autorisierungsaufforderung angezeigt",
    "Legal" : "Legal",
    "Available Services" : "Verfügbare Dienste",
    "Link" : "Verknüpfung",
    "Disconnect" : "Trennen",
    "Agreed" : "Vereinbart"
};